/**
 * Shows the running web-app version (the single source of truth from
 * package.json) plus the deployed commit SHA, both injected at build time by
 * vite.config.ts. No network call — works offline and reflects exactly the
 * build the user is running, which is what testers/support need to report.
 */
export function Version() {
	return (
		<div className="text-xs text-gray-500">
			v{__APP_VERSION__} ({__APP_COMMIT__})
		</div>
	);
}
